import { Link } from "react-router-dom";
import BottomFooter from "./BottomFooter";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";

function Layout({children}) {
    return (
        <>
            <Header category={false} />
            <main>
                <div className="d-flex align-items-start">
                    <Sidebar />
                    <div className="main-content flex-grow-1" style={{width: "calc(100% - 265px)"}}>
                        {children}
                    </div>
                </div>
            </main>
            <Footer />
            <BottomFooter />
        </>
    )
}
export default Layout;